export default __webpack_public_path__ + "static/alfred_find_file-50688151bf66adab42af2ed500d29b4f.png";